import CircularProgress from "@mui/material/CircularProgress";
import { ReactElement, Suspense } from "react";

export const suspended = (element: ReactElement) => (
  <Suspense fallback={<CircularProgress />}>{element}</Suspense>
);
